import React, { useEffect, useState, useCallback } from "react";
import api from "../../lib/api";
import { formatDate } from "../../lib/format";
import { toast } from "sonner";

const LEVEL_COLORS = { limpio: "#10b981", leve: "#3b82f6", moderado: "#C9A227", severo: "#ef4444" };

export default function SargassumTab() {
  const [list, setList] = useState([]);
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const load = useCallback(() => api.get("/sargassum").then(r => setList(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const upload = async () => {
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData(); fd.append("file", file);
      const { data } = await api.post("/sargassum", fd, { headers: {"Content-Type": "multipart/form-data"} });
      toast.success("Clasificado: " + data.level + " (~" + data.coverage_pct + "%)");
      setFile(null); load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error");
    } finally { setUploading(false); }
  };
  return (
    <div className="max-w-3xl grid gap-4">
      <div className="q-card p-6">
        <h3 className="font-semibold mb-3">Reporte fotográfico diario</h3>
        <input data-testid="sargassum-file" type="file" accept="image/*" capture="environment" onChange={(e) => setFile(e.target.files && e.target.files[0])} className="text-sm"/>
        <button onClick={upload} disabled={!file || uploading} data-testid="sargassum-upload" className="q-btn-primary mt-3 disabled:opacity-40">
          {uploading ? "Analizando con IA…" : "Enviar y clasificar"}
        </button>
      </div>
      <div className="grid gap-2">
        {list.map(s => (
          <div key={s.id} className="q-card p-3 flex items-center gap-3">
            <div className="h-3 w-3 rounded-full" style={{background: LEVEL_COLORS[s.level] || "#6b7280"}}/>
            <div className="flex-1">
              <div className="text-sm font-semibold capitalize">{s.level} · ~{s.coverage_pct}%</div>
              <div className="text-xs text-[color:var(--q-muted)]">{s.observations}</div>
            </div>
            <div className="q-label text-[color:var(--q-muted)]">{formatDate(s.date)}</div>
          </div>
        ))}
        {list.length === 0 && <div className="q-card p-6 text-center text-[color:var(--q-muted)]">Sin registros. Sube la primera foto de playa del día.</div>}
      </div>
    </div>
  );
}
